import { BodyBlockV2Item } from 'constants/bodyBlocks';

import { collapseOnePlusManyToSingleSlot } from 'components/TemplatesStudio/bodyBlocksOrderV2.utils';

export const normalizeBodyBlocksV2ForPreview = (
  items: BodyBlockV2Item[]
): BodyBlockV2Item[] => collapseOnePlusManyToSingleSlot(items);
